export default "__VITE_ASSET__Fz5Dq$M3__"